import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
const tenantId = appConfig.tenantId;

const endpoint = "target-groups";
const generateHeaders = (jwtToken) => ({
	headers: {
		Authorization: jwtToken
	}
});
const TargetGroupsProvider = Object.freeze({
	getAll(params, jwtToken) {
		return BifrostBackendNestApi.get("intusr/targetGroups", {
			...generateHeaders(jwtToken),
			params: {
				tenantId,
				...params
			}
		})
			.then((response) => response.data);
	},
	getOne(id, jwtToken) {
		return BifrostBackendApi.get(`${endpoint}/${id}`, {
			...generateHeaders(jwtToken),
			params: {
				tenantId
			}
		})
			.then((response) => response.data);
	},
	create(targetGroupData, jwtToken) {
		return BifrostBackendApi
			.post(endpoint,
				{
					tenantId,
					...targetGroupData
				},
				generateHeaders(jwtToken))
			.then((response) => response.data);
	},
	update(id, updatedData, jwtToken) {
		return BifrostBackendApi
			.put(`${endpoint}/${id}`,
				{
					tenantId,
					...updatedData
				},
				generateHeaders(jwtToken))
			.then((response) => response.data);
	},
	delete(id, jwtToken) {
		return BifrostBackendApi
			.delete(`${endpoint}/${id}`, {
				...generateHeaders(jwtToken),
				params: {
					tenantId
				}
			})
			.then((response) => response.data);
	}
});

export default TargetGroupsProvider;
